/**
 * React Native Image Crop Picker stub for web
 * Provides a mock implementation for image picking and cropping
 */

declare const document: any;

// Mock implementation of image crop picker
const ImageCropPicker = {
  openPicker: async (options: any = {}) => {
    return new Promise((resolve, reject) => {
      // Create a file input element
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';

      input.onchange = async (event: any) => {
        const file = event.target.files?.[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            resolve({
              path: e.target.result,
              filename: file.name,
              mime: file.type,
              size: file.size,
              width: 0,
              height: 0,
              cropRect: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
              },
            });
          };
          reader.readAsDataURL(file);
        }
      };

      input.click();
    });
  },

  openCamera: async (options: any = {}) => {
    return new Promise((resolve, reject) => {
      // Create a file input element with camera capture
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.capture = 'environment';

      input.onchange = async (event: any) => {
        const file = event.target.files?.[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            resolve({
              path: e.target.result,
              filename: file.name,
              mime: file.type,
              size: file.size,
              width: 0,
              height: 0,
              cropRect: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
              },
            });
          };
          reader.readAsDataURL(file);
        }
      };

      input.click();
    });
  },

  clean: async () => {
    // No cleanup needed for web
    return Promise.resolve();
  },

  cleanSingle: async (path: string) => {
    // No cleanup needed for web
    return Promise.resolve();
  },
};

export default ImageCropPicker;
